import React from 'react';

import { Outlet } from 'react-router-dom';

const PrepRequestContent = () => {
  return <Outlet />;
};

export default PrepRequestContent;
